<app-assignment-editor *ngIf="accounts && assignment"
  [assignment]="assignment" 
  [contactDatasource]="contactSearch" 
  [accounts]="accounts" 
  [files]="files" 
  [planningSettings]="planningSettings" 
  [readonly]="readonly" 
  [planLocked]="planLocked"
  [editableContact]="editableContact"
  [cancelable] = "cancelable"
  [accountId] = "accountId"
  [date] = "date"
  (fileUpload)="handleFileUpload($event)" 
  (fileDelete)="handleFileDelete($event)"
  (save)="save($event)"
  (cancel)="cancel()">
</app-assignment-editor>